import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Public Pages
import Home from './pages/public/Home';
import Blog from './pages/public/Blog';
import BlogPost from './pages/public/BlogPost';
import BreweryPage from './pages/public/BreweryPage';
import AllBreweries from './pages/public/AllBreweries';
import HowItWorksPage from './pages/public/HowItWorksPage';
import DigitalMenu from './pages/public/DigitalMenu';
import UserProfile from './pages/public/UserProfile';
import NotFound from './pages/public/NotFound';
import BeerEncyclopedia from './pages/public/BeerEncyclopedia';
import BeerSubmission from './pages/public/BeerSubmission';
import Terms from './pages/public/Terms';
import Privacy from './pages/public/Privacy';

// Auth
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';

// Unified Dashboard
import DashboardManager from './pages/DashboardManager';

// Admin Pages (Sub-routes)
import AdminProducts from './pages/admin/Products';
import AdminOrders from './pages/admin/Orders';
import AdminSettings from './pages/admin/Settings';
import AdminBilling from './pages/admin/Billing';
import AdminReports from './pages/admin/Reports';
import AdminAccounts from './pages/admin/Accounts';
import BlogAdmin from './pages/admin/BlogAdmin';
import Reviews from './pages/admin/Reviews';
import AdminPosts from './pages/admin/AdminPosts';
import AdminEncyclopedia from './pages/admin/AdminEncyclopedia'; // Added

// User Pages (Sub-routes)
import UserOrders from './pages/user/Orders';
import UserProfileEdit from './pages/user/Profile';
import UserFavorites from './pages/user/Favorites';

// Layouts
import PublicLayout from './layouts/PublicLayout';
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="loja/:slug" element={<BreweryPage />} />
            <Route path="cervejarias" element={<AllBreweries />} />
            <Route path="como-funciona" element={<HowItWorksPage />} />
            <Route path="perfil/:slug" element={<UserProfile />} />
            
            {/* Encyclopedia Routes */}
            <Route path="cervejas" element={<BeerEncyclopedia />} />
            <Route path="cervejas/nova" element={<BeerSubmission />} />
            <Route path="cervejaria/:slug" element={<BreweryPage />} />
            
            {/* Legal Pages */}
            <Route path="termos" element={<Terms />} />
            <Route path="privacidade" element={<Privacy />} />
          </Route>

          {/* Standalone Public Routes */}
          <Route path="/menu/:slug" element={<DigitalMenu />} />

          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Unified Dashboard Route */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }>
            <Route index element={<DashboardManager />} />
            <Route path="orders" element={<UserOrders />} />
            <Route path="profile" element={<UserProfileEdit />} />
            <Route path="favorites" element={<UserFavorites />} />
          </Route>

          {/* Admin/Brewery Routes */}
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['brewery_owner', 'admin']}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<DashboardManager />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="billing" element={<AdminBilling />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="accounts" element={<AdminAccounts />} />
            <Route path="encyclopedia" element={<AdminEncyclopedia />} /> {/* Added Route */}
            <Route path="blog" element={<BlogAdmin />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="posts" element={<AdminPosts />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;